exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assign-select .multiselect__option{padding-left:25px}.assign-select .multiselect__option--disabled{padding-left:10px}.form-control::-webkit-input-placeholder{color:#adadad}.form-control::-moz-placeholder{color:#adadad}.form-control:-ms-input-placeholder{color:#adadad}.form-control::-ms-input-placeholder{color:#adadad}.form-control::placeholder{color:#adadad}.multiselect__option span{white-space:normal!important;line-height:1.5}", ""]);

// exports
